import { Expose } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, IsDateString } from "class-validator";
import { BookingServicesOrderInfo } from "./BookingServiceOrderInfo";

export class BookingServicesItemsEdit {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  recordLocator!: string;
  @IsString()
  @Expose()
  gds!: string;
  @IsDateString()
  @Expose()
  creationDate!: string;
  @IsNumber()
  @Expose()
  grandTotal!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  clientSurnameName!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  firstNumber!: string;
  @IsBoolean()
  @Expose()
  isVoided!: boolean | null;
  @IsBoolean()
  @Expose()
  isCancelled!: boolean | null;
  @IsBoolean()
  @Expose()
  isLocked!: boolean | null;
  @IsBoolean()
  @Expose()
  isClonned!: boolean | null;
  @IsString()
  @Expose()
  serviceTypeCode!: string;
  @IsString()
  @Expose()
  captureName!: string;
  @IsString()
  @Expose()
  @IsOptional()
  captureOrderId!: string;
  @IsBoolean()
  @Expose()
  isCaptured!: boolean | null;
  @IsBoolean()
  @Expose()
  canDeleteCapture!: boolean | null;
  @IsBoolean()
  @Expose()
  inOrder!: boolean | null;
  @IsString()
  @Expose()
  @IsOptional()
  comment!: string;
  @IsArray()
  @Expose()
  orderInfo!: Array<BookingServicesOrderInfo>;

  constructor() {
    this.id = 0;
    this.recordLocator = "";
    this.gds = "";
    this.creationDate = "";
    this.grandTotal = 0;
    this.currency = "";
    this.clientSurnameName = "";
    this.name = "";
    this.firstNumber = "";
    this.isVoided = null;
    this.isClonned = null;
    this.isCancelled = null;
    this.serviceTypeCode = "";
    this.captureName = "";
    this.captureOrderId = "";
    this.isCaptured = null;
    this.canDeleteCapture = null;
    this.inOrder = null;
    this.comment = "";
    this.orderInfo = new Array<BookingServicesOrderInfo>();
  }
}
